import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import AssetAllocationHead from '@/types/table/assetAllocationHead';
import { AssetAllocationDetailData } from '@/api/generated/assetAllocationDetailController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface AssetAllocationHeadData extends AssetAllocationHead {
  assetAllocationDetailList?: AssetAllocationDetailData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class AssetAllocationHeadController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<AssetAllocationHeadData>>(API_CONTEXT + '/app/assetAllocationHead/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<AssetAllocationHeadData>(API_CONTEXT + '/app/assetAllocationHead/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/assetAllocationHead/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/assetAllocationHead/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/assetAllocationHead/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAllocationHead/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAllocationHead/update', params, httpOptions);
  }

    static checkDeptExists(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAllocationHead/checkDeptExists', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAllocationHead/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAllocationHead/deleteBatch', params, httpOptions);
  }
  static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<AssetAllocationHeadData>>(API_CONTEXT + '/app/dept/getUserInformation', params, httpOptions);
  }
}
